import { refContainsTarget } from "@prismicio/editor-support/React"
import { add } from "@prismicio/editor-support/Set"
import { type RefObject, useEffect, useState } from "react"

interface UseTagFieldProps {
  selectedValues: Set<string>
  setOpen: (open: boolean) => void
  fieldRef: RefObject<HTMLDivElement>
  onSelectedValuesChange: (selectedValues: Set<string>) => void
}

export function useTagField(props: UseTagFieldProps) {
  const { selectedValues, setOpen, fieldRef, onSelectedValuesChange } = props

  const [searchText, setSearchText] = useState("")

  useEffect(() => {
    function onDocumentMouseDown(event: MouseEvent) {
      const isClickInside = refContainsTarget(fieldRef, event.target)

      setOpen(isClickInside)

      if (!isClickInside) setSearchText("")
    }

    document.addEventListener("mousedown", onDocumentMouseDown)

    return () => {
      document.removeEventListener("mousedown", onDocumentMouseDown)
    }
  })

  function addItemToSelectedValues(valueToAdd: string) {
    const updatedSet = add(selectedValues, valueToAdd)
    setSearchText("")
    return onSelectedValuesChange(updatedSet)
  }

  function onCreateTag() {
    addItemToSelectedValues(searchText)
    setSearchText("")
  }

  return {
    searchText,
    setSearchText,
    onCreateTag,
    addItemToSelectedValues,
  }
}
